import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { Weight, Ruler, Box, Mountain } from "lucide-react";

const FIGURES = [
  { icon: Weight, target: 3000, suffix: " kg", label: "Capacité de levage" },
  { icon: Ruler, target: 45, suffix: " cm", label: "Levage maximum" },
  { icon: Box, target: 240, suffix: " kg", label: "Poids total" },
  { icon: Mountain, target: 9, suffix: "°", label: "Franchissement de pente" },
];

function Counter({ target, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref} className="font-display text-4xl md:text-5xl font-black tracking-tighter">
      {val.toLocaleString("fr-FR")}{suffix}
    </span>
  );
}

export default function KeyFigures() {
  return (
    <section data-testid="key-figures" className="py-16 lg:py-20 bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
          {FIGURES.map((f, i) => (
            <motion.div key={f.label}
              initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }}
              className="bg-[#0A0A0A] p-7 text-center">
              <f.icon className="h-6 w-6 text-[#E63946] mx-auto" />
              <div className="mt-3"><Counter target={f.target} suffix={f.suffix} /></div>
              <div className="font-mono-tech text-xs uppercase tracking-wider text-white/50 mt-2">{f.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
